import PropTypes from 'prop-types';
import React from 'react';
import StopEta from './StopEta';
import {
  estimatedEtaPropTypes, geofencingAssetPropTypes, monitoringOrderStopAssetSnapshotPropTypes,
} from '../../../types';
import ArrivingTime from './ArrivingTime';
import MonitoringOrderStopSnapshot from './MonitoringOrderStopSnapshot';
import { stopPropTypes } from '../../../types/stop.type';
import { isOperationalStop } from '../../../types/stopBehaviour.type';

const TripStopDetails = ({
  stop, geofencingWithEtaEnabled, eta, hasGeofencingData, geofencingData, stopAssetSnapshots,
}) => {
  const handleCalculateButtonClick = () => eta.onCalculate(stop);
  /*
   * A non-operational stop is not an ETA target: the backend answers NOT_AN_OPERATIONAL_STOP, so the
   * "Calculate ETA" action has nothing to offer. Suppressing the whole widget also removes
   * StopEtaStatusLabel, which matters because that +/-30-minute early/late verdict is computed here
   * in the browser from scheduledArrival - server-side alert suppression alone would not stop the UI
   * telling the user a waypoint is "delayed".
   */
  function getStopEta() {
    return geofencingWithEtaEnabled && isOperationalStop(stop) ? (
      <StopEta
        etas={eta.data}
        calculateEta={handleCalculateButtonClick}
        loading={eta.loading}
        disabled={eta.disabled}
        scheduledArrival={stop.timeSlot.start}
        tooltipKey={eta.tooltipKey}
        geofencingData={geofencingData}
      />
    ) : null;
  }

  const stopInfo = () => {
    if (stopAssetSnapshots.hasData) {
      return stopAssetSnapshots.data
        ?.map((asset) => (<MonitoringOrderStopSnapshot key={asset.assetId} stopAssetSnapshotData={asset} />));
    }
    return hasGeofencingData
      ? geofencingData?.map((asset) => (
        <ArrivingTime key={asset.assetId} geofencingData={asset} />
      ))
      : getStopEta();
  };

  return (
    <>
      {stopInfo()}
    </>
  );
};

TripStopDetails.propTypes = {
  stop: stopPropTypes.isRequired,
  geofencingWithEtaEnabled: PropTypes.bool.isRequired,
  eta: PropTypes.shape({
    loading: PropTypes.bool,
    data: PropTypes.arrayOf(estimatedEtaPropTypes),
    onCalculate: PropTypes.func,
    tooltipKey: PropTypes.string,
    disabled: PropTypes.bool,
  }).isRequired,
  geofencingData: PropTypes.arrayOf(
    geofencingAssetPropTypes,
  ),
  stopAssetSnapshots: PropTypes.shape({
    hasData: PropTypes.bool,
    data: PropTypes.arrayOf(monitoringOrderStopAssetSnapshotPropTypes),
  }).isRequired,
  hasGeofencingData: PropTypes.bool.isRequired,
};

TripStopDetails.defaultProps = {
  geofencingData: {},
};

export default TripStopDetails;
